export default {
    'not_approved': 'This account is not approved for beta access. Please request access here.',
    'email_not_verified': 'Please verify your email before logging in.',
    'none': ''
  };